import { useState, useEffect } from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu } from "lucide-react";
import SideNav from "./SideNav";
import Footer from "./Footer";
import { useLang } from "@/context/LangContext";

export default function Layout() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { lang } = useLang();

  useEffect(() => {
    setOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[#FBF5F1] text-[#3D3238]">
      <header className="fixed top-0 left-0 right-0 z-40 bg-[#FBF5F1]/85 backdrop-blur-md border-b border-[rgba(61,50,56,0.08)]">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-16 h-16 sm:h-20 flex items-center justify-between">
          <button
            data-testid="side-nav-toggle"
            onClick={() => setOpen(true)}
            className="flex items-center gap-3 text-[#3D3238] group"
            aria-label="Open menu"
          >
            <Menu className="w-5 h-5 text-[#C6899E] transition-transform group-hover:rotate-6" />
            <span className="hidden sm:block text-xs uppercase tracking-[0.24em] text-[#8C7E83] group-hover:text-[#3D3238] transition-colors">Menu</span>
          </button>

          <Link to="/" data-testid="brand-home-link" className="absolute left-1/2 -translate-x-1/2">
            <span className="font-serif text-2xl sm:text-3xl tracking-[0.18em] font-medium">UNFILTERED</span>
          </Link>

          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.15em] text-[#9C8F94]">
            <span className="text-[#C6899E]">{lang.toUpperCase()}</span>
          </div>
        </div>
      </header>

      <SideNav open={open} onClose={() => setOpen(false)} />

      <main className="flex-1 pt-16 sm:pt-20">
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </main>

      <Footer />
    </div>
  );
}
